import {Box, Flex, Text} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {SupportButtons} from 'components/shared';
import {IProfileItem} from 'components/shared/profile/utils';
import {useAuth, useTranslation} from 'hooks';
import {useRouter} from 'next/router';
import {FC, PropsWithChildren} from 'react';
import {TranslationKeys} from 'translations';
import NextImageUI from 'ui/NextImage';

export const MenuItemBody: FC<PropsWithChildren<IProfileItem>> = ({
  icon,
  subTitle,
  title,
  name,
  onClick,
  children,
  href,
}) => {
  const isSupportItem = name === 'support';
  const isLogout = name === 'logout';
  const {push} = useRouter();
  const {logout} = useAuth();
  const {t} = useTranslation();

  const handleClick = (e: any) => {
    if (href) {
      push(`${href}`);
    }
    if (onClick) {
      e.preventDefault();
      onClick();
    }
    if (isLogout) {
      logout();
    }
  };

  return (
    <Flex
      pointerEvents={isSupportItem ? 'none' : 'auto'}
      flexDirection="column"
      py="10px"
      alignItems="center"
      justifyContent="space-between"
      w="100%"
      onClick={handleClick}
      _hover={{color: colors.pink}}
      cursor={isSupportItem ? 'default' : 'pointer'}
    >
      <Flex alignItems="center" justifyContent="space-between" w="100%">
        <Flex alignItems="center">
          <Flex alignSelf="flex-start" minW="32px" h="32px">
            <NextImageUI
              style={{
                marginLeft: '0px',
              }}
              width={32}
              height={32}
              src={icon}
              alt="Menu item"
            />
          </Flex>
          <Flex flexDirection="column" ml="15px" position="relative">
            {children}
            <Text fontSize="16px" fontWeight={500}>
              {t(title as TranslationKeys)}
            </Text>
            <Text fontSize="12px" fontWeight={500} color={colors.black}>
              {subTitle && t(subTitle as TranslationKeys)}
            </Text>
          </Flex>
        </Flex>
        {!isSupportItem && <NextImageUI width={24} height={24} src="/slider/arrow-icon.svg" alt="Arrow" />}
      </Flex>
      {isSupportItem && (
        <Box mt="15px" ml="45px" alignSelf="flex-start" pointerEvents="auto">
          <SupportButtons t={t} />
        </Box>
      )}
    </Flex>
  );
};
